const baseURL =process.env.VUE_APP_API_URL
const url =process.env.VUE_APP_PC_URL

 export {
	baseURL,url
}